export default __webpack_public_path__ + "static/media/editdisabled.f257c3a9.svg";